import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import Navbar from "./components/Navbar";
import HomePage from "./components/HomePage";
import TermsOfUse from "./components/TermsOfUse";
import Impressum from "./components/Impressum";
import PrivacyPolicy from "./components/PrivacyPolicy";
import PrivacyPolicyDe from "./components/PrivacyPolicyDe";
import Footer from "./components/Footer";

function App() {
  return (
      <Router>
        <div className="app-container">
          <Navbar />
          {/* Main Content (With Padding to Avoid Navbar Overlap) */}
          <div className="content" style={{ paddingTop: "70px", padding: "20px" }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/privacy-policy-de" element={<PrivacyPolicyDe />} />                        
            </Routes>          
          </div>
          <Footer />
        </div>
      </Router>
  );
}

export default App;
